const state = {
  recurrents: {
    data: [],
  },
  recurrentHistorical: {
    recurrent_name: '',
    data: [],
  },
  total: 0,
  periodicities: [
    { value: 'diario1', label: 'Diário (Todos os Dias)' },
    { value: 'diario2', label: 'Diário (Segunda a Sexta)' },
    { value: 'semanal', label: 'Semanal' },
    { value: 'mensal', label: 'Mensal' },
  ],
  recurrent: {
    id: '',
    name: '',
    periodicity: '',
    estimated_value: '',
    template: {
      id: '',
      name: '',
      tag: '',
    },
  },
};

export default state;
